// Copyright (C) 2023-2025 Skylark Drones

import v4Api from '@/config/v4Api'
import v1EventGatewayApi from '@/config/v1EventGatewayApi'
import internalApi from '@/config/internalApi'
import NoVersionApi from './noVersionApi'

export const v4ApiInstance = new v4Api()
export const v1EventGatewayInstance = new v1EventGatewayApi()
export const internalApiInstance = new internalApi()
export const noVersionApiInstance = new NoVersionApi()

// Base Backend API
export default v4ApiInstance
